/* Connectors */
import {IdentityProvider} from '@app/views/sso/identity-providers/identity-provider';

export class ETXApplication {
    // public allowChangePassword: boolean;
    // public allowResetApplicationCredentials: boolean;
    public assets: ETXAsset[];
    // public consoleUrl: string;
    // public hashCode: number;
    // public organization: ETXPersonOrganization;
    // public person: ETXPerson;
    public ssoUrl: string;
}

export class ETXAsset {
    // public accessory: string;
    public appId: string;
    public children: ETXAsset[];
    // public correctCaptCredentials: boolean;
    // public iconFileName: string;
    public id: number;
    public name: string;
    // public order: number;
    // public parentId: number;
    // public type: string;
    // public url: string;
}

export class ETXPersonOrganization {
    // public accountType: any;
    // public address: any;
    // public alias: string;
    // public capacity: number;
    // public country: string;
    // public description: string;
    // public information: string;
    // public locationDirectory: string;
    // public name: string;
    // public objectId: any;
    // public orgId: number;
    // public parentId: number;
    // public region: string;
    // public status: string;
}

export class ETXPerson {
    // public authorities: string[];
    // public country: string;
    // public externalAttributes: any;
    // public orgAdministrator: boolean;
    // public orgId: number;
    // public orgType: string;
    // public personDetails: ETXPersonDetails;
    // public personId: number;
    // public personStatus: string;
    // public personType: string;
    // public region: string;
    // public resellerId: any;
    // public roleId: string;
    // public roles: ETXRole[];
    // public schoolAdministrator: boolean;
    // public studentDetails: any;
    // public sysadmin: boolean;
    // public systemAdministrator: boolean;
    // public vendorId: any;
}

export class ETXPersonDetails {
    // public addresses: string;
    // public dateOfBirth: any;
    // public email: string;
    // public familyName: string;
    // public firstName: string;
    // public gender: string;
    // public phone: any;
    // public zipcode: any;
}

export class ETXRole {
    // public description: string;
    // public prioritization: string;
    // public roleId: string;
}

/* Organization */

export class ETXOrganization {
    public parentOrg: number;
    public parentName: string;
    public orgType: string;
    public orgId: number;
    public orgname: string;
    public alias: string;
    public capacity: number;
    public loginGenAlg: string;
    public passwordGenAlg: string;
    public idpAuth: boolean;
    public disallowEmailNotifications: boolean;
    public hostId: number;
    public hostName: string;
    public region: string;
    public country: string;
    public attributes: any;
    public templates: string;
    public reconciliation: ETXOrganizationReconciliation[];
    public redundantOrganizations: ETXRedundantOrganization[];
    public addresses: ETXOrganizationAddress[];
    public resellerId: any;
    public resellerName: string;
    public requestResellerId: any;
    public allowPasswordReset: boolean;
    public inheritSkinParentOrg: boolean;
    public authProviders: IdentityProvider[];
    public allowResetApplicationCredentials: boolean;
    public orgParameters: ETXOrganizationOrgParameters;
    public bindingId: string;
    public logoImage: string;
    public logoUrl: string;
    public passportLogoImage: string;
    public passportLogoUrl: string;
    public newOrganization: boolean;
}

export class ETXSubOrganization {
    billingState: string;
    country: string;
    guid: string;
    id: number;
    name: string;
    parentName: string;
    region: string;
    type: string;
}

export class ETXOrganizationReconciliation {
    public reconciliationId: number;
    public organizationId: number;
    public source: string;
    public entityType: string;
    public externalId: string;
    public internalId: string;
}

export class ETXRedundantOrganization {
    public orgId: number;
    public parentId: number;
    public name: string;
    public orgType: string;
    public countryIso: string;
    public stateIso: string;
    public parentName: string;
    public countryName: string;
    public stateName: string;
}

export class ETXOrganizationAddress {
    public adderssId: number;
    public ownerId: number;
    public addressType: string;
    public region: string;
    public country: string;
    public state: string;
    public city: string;
    public street: string;
    public house: string;
    public phone: string;
    public zipCode: string;
    public additionalInfo: string;
}

export class ETXOrganizationOrgParameters {
    public objectId: number;
    public dnome: string;
    public descriptorId: number;
    public dname: string;
    public ownerId: number;
    public idpAuth: boolean;
    public disallowEmailNotifications: boolean;
    public sourceOrgForRolematrix: number;
    public resellerId: any;
    public hostId: number;
    public loginUrl: string;
    public logoutUrl: string;
    public passwordPolicy: string;
    public saveEncryptedPassword: boolean;
    public allowedRolesToChangePassword: string;
    public organizationLogo: string;
    public organizationVideoLink: string;
    public organizationVideoName: string;
    public organizationFile: string;
    public allowPasswordReset: boolean;
    public suborganizationSharesLoginDomain: string;
    public copyEtaCredsForConnectors: any;
    public inheritSkinParentOrg: any;
    public defaultSubscriptionForSuborganization: string;
    public initialStatusForSuborganization: string;
    public exportToGoogleDomain: any;
    public adfsEntityId: any;
    public allowResetApplicationCredentials: boolean;
    public externalIdsToExpose: string[];
    public externalIdsToRestrictedWrite: string[];
    public skinLogoUrl: string;
    public passportSkinLogoUrl: string;
    public premiumSubscriptionDefault: any;
}
